import React, {PureComponent} from 'react';
import ReactGA from "react-ga";
import toastr from 'toastr';
import { getJwt } from '../../../services/authService';
import http from '../../../services/httpService';
import AddPaymentMethodModal from '../../modals/AddPaymentMethodModal';
import EditAlphanumericIdModal from '../../modals/EditAlphanumericIdModal';
import StripeReplacementModal from '../../modals/StripeReplacementModal';
import ChartLoader from '../../utils/chart-loader';
import chartLoader from '../../utils/chart-loader';
import SinglePaymentMethod from './SinglePaymentMethod';

class BillingPaymentMethods extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            error: '',
            projectPaymentMethods: [],
            otherPaymentMethods: [],
            addPaymentMethodModalActive: false,
            projectId: '',
            userCustomer: '',
            project: '',
            stripeReplacementModal: false,
            getPaymentMethodsLoader: false
            //sharedProject: ''
        }
    }

    async componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        let project = await user.sources.data.length ? await user.sources.data.find(source => source.id.toString() === projectId.toString()) : '';
        //let sharedProject = await user.feeds_shared.data && user.feeds_shared.data.length ? await user.feeds_shared.data.find(feed => feed.id.toString() === projectId.toString()) : '';
        await this.setState({projectId, project,
        //    sharedProject
        })
        if(user && user.customer){
            await this.getPaymentMethods();
            await this.setState({userCustomer: user.customer, projectId, project,
            //    sharedProject
            })
        }
        // console.log('didMount: ',user, projectId, this.state.projectId, this.state.userCustomer, user.customer, project, sharedProject)
    }

    async componentDidUpdate(){
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        let project = await user.sources.data.length ? await user.sources.data.find(source => source.id.toString() === projectId) : '';
        //let sharedProject = await user.feeds_shared.data && user.feeds_shared.data.length ? await user.feeds_shared.data.find(feed => feed.id.toString() === projectId) : '';
        if(projectId && ((projectId.toString() !== this.state.projectId.toString()) || (!this.state.userCustomer && user.customer))){
            await this.setState({userCustomer: user.customer, project,
                //sharedProject,
                projectId})
            await this.getPaymentMethods()
        }
        // console.log('didUpdate: ',user, projectId, this.state.projectId, this.state.userCustomer, user.customer, project, sharedProject)
    }

    handleGoToSecondStep = () => {
        if (this.props.fundsAmount > 19){
            this.props.handleStepChange(2)
            this.setState({error: ''})
        } else {
            this.setState({
                error: 'Amount needs to be at least $20.00'
            })
        }
    }

    getPaymentMethods = async () =>{
        this.setState({ getPaymentMethodsLoader: true })
        let user = await this.props.user;
        let projectId = await this.props.selectedSource;
        // console.log('getPaymentMethods: ', user, projectId);
        if(user && user.customer){
            /*GET PAYMENT METHODS PROJECT*/
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                // console.log('Payment Methods: ', result)
                let projectPaymentMethods = await result && result.data && result.data.project_payment_methods ? result.data.project_payment_methods : [];
                let userPaymentMethods = await result && result.data && result.data.user_payment_methods ? result.data.user_payment_methods : [];
                // console.log('projectPM, userPM: ', projectPaymentMethods, userPaymentMethods)
                await this.setState({ projectPaymentMethods: projectPaymentMethods, otherPaymentMethods: userPaymentMethods, getPaymentMethodsLoader: false })
            } catch(e) {
                this.setState({ getPaymentMethodsLoader: false })
                toastr.error("Couldn't get payment methods.")
            }
        }
    }

    render() {

        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2 className='page-title'><strong>Workspace Payment Methods</strong></h2>
                    <p>Workspace default payment methods</p>
                    {this.state.getPaymentMethodsLoader && (!this.state.projectPaymentMethods || !this.state.projectPaymentMethods.length) ?
                        <div className='get-payment-methods-loader-container'>
                            <ChartLoader/>
                        </div>
                        :
                        ''
                    }
                    {this.state.projectPaymentMethods.map((method, index) => method.payment_method_id ?
                        <SinglePaymentMethod
                            key={index}
                            subscription_renewal_problem={this.props.subscription_renewal_problem || false}
                            method={method}
                            user={this.props.user}
                            type={'project'}
                            updateMethodsList={this.getPaymentMethods}
                            history={this.props.history}
                            updatePaymentMethods={ this.getPaymentMethods }
                            project={this.state.project}
                            selectedSource={this.props.selectedSource}
                        />
                        : '')}

                    <button
                        className='btn-action btn-480 margin-top-20'
                        id='add-payment-method'
                        onClick={()=>this.setState({addPaymentMethodModalActive: true})}
                        // onClick={()=>this.setState({stripeReplacementModal: true})}
                    >
                        Add Payment Method
                    </button>
                    <h2 className='page-title' style={{marginTop: 50}}><strong>Other Available Payment Methods</strong></h2>
                    <p>These cards are all saved cards that have been used.</p>

                    {/*{this.state.otherPaymentMethods.map(method => ((this.state.projectId.toString() !== method.project_id.toString()) || method.payment_method_id) ?*/}
                    {this.state.getPaymentMethodsLoader && (!this.state.projectPaymentMethods || !this.state.projectPaymentMethods.length) ?
                        <div className='get-payment-methods-loader-container'>
                            <ChartLoader/>
                        </div>
                        :
                        ''
                    }
                    {this.state.otherPaymentMethods.map((method, index) => (this.state.projectPaymentMethods.find(projectPM => projectPM.payment_method_id.toString() === method.payment_method_id.toString())) ?
                        ''
                        :
                        <SinglePaymentMethod
                            key={index}
                            subscription_renewal_problem={this.props.subscription_renewal_problem || false}
                            method={method}
                            user={this.props.user}
                            updateMethodsList={this.getPaymentMethods}
                            type={'other'}
                            history={this.props.history}
                            updatePaymentMethods={ this.getPaymentMethods }
                            project={this.state.project}
                            selectedSource={this.props.selectedSource}
                        />
                    )}
                </div>
                <AddPaymentMethodModal
                    showModal={this.state.addPaymentMethodModalActive}
                    handleClose={() => this.setState({addPaymentMethodModalActive: false})}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updatePaymentMethods={ this.getPaymentMethods }
                    newPaymentMethodForProject={true}
                    updateUserFromServer={this.props.updateUserFromServer}
                    project={this.state.project
                    //|| this.state.sharedProject
                    || ''}
                    selectedSource={this.props.selectedSource}
                />
                {/*<StripeReplacementModal*/}
                {/*    showModal={this.state.stripeReplacementModal}*/}
                {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                {/*    maxWidth={600}*/}
                {/*    history={this.props.history}*/}
                {/*    user={this.props.user}*/}
                {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                {/*/>*/}
            </div>
        )
    }
}

export default BillingPaymentMethods;